import styled from 'styled-components';

/**
 * Used by `ProgressStepperStep` to display an icon or dot that reflects a step's status.
 *
 * @since 8.57.0
 */
var ProgressStepperStepDot = /*#__PURE__*/styled.span.withConfig({
  displayName: "ProgressStepperStepDot",
  componentId: "c11n-8-99-3__sc-abxubx-0"
})([""]);
ProgressStepperStepDot.displayName = 'ProgressStepperStepDot';

/** @component */
export { ProgressStepperStepDot };